import noUiSlider from 'nouislider';
export default function rangeSlider(callback) {
  var slider = document.getElementById('slider');
  var input0 = document.querySelector('.range-slider__field-min') || null;
  var input1 = document.querySelector('.range-slider__field-max') || null;
  var inputs = [input0, input1];
  var values = [input0.dataset['min'], input1.dataset['max']];
  var currentMinValue = input0.getAttribute('data-value');
  var currentMaxValue = input1.getAttribute('data-value');
  var minValue = input0.getAttribute('data-min');
  var maxValue = input1.getAttribute('data-max');
  noUiSlider.create(slider, {
    start: [parseInt(currentMinValue), parseInt(currentMaxValue)],
    connect: true,
    tooltips: [true, true],
    range: {
      'min': parseInt(minValue),
      'max': parseInt(maxValue)
    }
  });
  slider.noUiSlider.on("update", function (values, handle) {
    inputs[handle].value = values[handle];
  });
  slider.noUiSlider.on("change", function (values, handle) {
    inputs[handle].value = values[handle];
    callback({
      inputMin: values[0],
      inputMax: values[1]
    });
  });
  inputs[0].addEventListener('change', function (e) {
    values[0] = e.target.value;
    slider.noUiSlider.set(values);
    callback({
      inputMin: values[0],
      inputMax: values[1]
    });
  });
  inputs[1].addEventListener('change', function (e) {
    values[1] = e.target.value;
    slider.noUiSlider.set(values);
    callback({
      inputMin: values[0],
      inputMax: values[1]
    });
  });
}